import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-milestone',
  templateUrl: './milestone.component.html',
  styleUrls: ['./milestone.component.css']
})
export class MilestoneComponent implements AfterViewInit{
    
  @Input() lessons: Array<any>;
  @Input() enrolledDate: any;
  @Input() activateLessonDeadlineNotification: boolean;

  ngAfterViewInit(): void {
    this.srcrollToLastCompletedLesson();
  }
  
  srcrollToLastCompletedLesson(){
    const container = document.getElementById("timeline");
    const latestCompletedLesson = Math.max(...this.lessons?.filter(l => l.completed)?.map(l => l.classposition));
    const item = document.getElementById(`${latestCompletedLesson}`);
    const totalContentWidth = container.scrollWidth;
    container.style.setProperty('--before-width', `${totalContentWidth}px`);    
    container.scrollLeft = item.offsetLeft  - container.offsetLeft;
  }
  
  setDate(milestone: any): Date | null {
    let timeVal: number = milestone.milestonetimenumber;
    let timeUnit: number = milestone.milestonetimeunit;
    if (timeVal > 0) {
      let date = milestone.usefixeddeadline ? new Date(milestone.publishdate) : new Date(this.enrolledDate);
      return timeUnit == 0 ? new Date(date.setHours(date.getHours() + timeVal)) : new Date(date.setDate(date.getDate() + timeVal));
    }
    return null;
  }
  deadlinePassed(milestone: any): boolean{
    let deadline = this.setDate(milestone);
    return new Date() > deadline;
  }
}
